import { createContext, useContext, useState } from "react";

const translations = {
  fr: {
    nav: {
      accueil: "Accueil",
      apropos: "À Propos",
      prestations: "Prestations",
      portfolio: "Portfolio",
      processus: "Processus",
      tarifs: "Tarifs",
      contact: "Contact",
      faq: "FAQ",
    },
    hero: {
      title1: "Création vidéo & photo",
      title2: "immobilier en Suisse",
      subtitle: "Photographe immobilier et vidéaste drone en Suisse romande. Sublimez vos biens avec des visuels professionnels qui vendent.",
      cta1: "Voir nos réalisations",
      cta2: "Réserver un shooting",
    },
    about: {
      label: "Agence de production immobilière",
      title: "Votre photographe et vidéaste immobilier en Suisse",
      p1: "Spécialisée dans la vidéo immobilière et la photographie de biens, Prodimmo accompagne les agences immobilières, promoteurs et particuliers en Suisse romande. Nos prises de vue par drone FPV et au sol mettent en valeur chaque propriété avec un rendu cinématique haut de gamme.",
      p2: "Du shooting photo immobilier à la vidéo drone aérienne, en passant par la gestion de vos réseaux sociaux, nous créons le contenu visuel qui transforme vos annonces en ventes.",
      stats: {
        experience: "Années d'Expérience",
        satisfaction: "Clients Satisfaits",
      },
      badge: "ans d'excellence",
      highlights: ["Drone FPV", "Cinéma 4K", "Réseaux sociaux", "Qualité premium"],
    },
    services: {
      label: "Nos Prestations",
      title: "Vidéo drone, photo immobilière & réseaux sociaux",
      drone: {
        title: "Vidéo Drone FPV & Aérien",
        desc: "Vidéo immobilière par drone FPV pour des prises de vue immersives et cinématiques. Survols fluides à travers les pièces et autour des bâtiments, un rendu inégalé pour vos biens.",
        badge: "Drone immobilier",
      },
      video: {
        title: "Vidéo & Photo Immobilière",
        desc: "Photographe immobilier professionnel avec matériel cinéma. Photos HDR et vidéos qui subliment les intérieurs, extérieurs et détails architecturaux.",
        badge: "Photo immobilière",
      },
      social: {
        title: "Gestion Réseaux Sociaux",
        desc: "Montage de Reels, TikTok et Shorts pour maximiser la visibilité de vos annonces immobilières en ligne. Stratégie de contenu et publications régulières.",
        badge: "Marketing digital",
      },
    },
    portfolio: {
      label: "Nos Réalisations",
      title: "Projets vidéo et photo immobilière",
      filters: { tous: "Tous", immobilier: "Immobilier", charpente: "Charpente", chantier: "Chantier" },
      client: "Client",
      projects: {
        payerne: "Bien immobilier, Payerne",
        arbaz: "Chalet, Arbaz",
        fromagerie: "Fromagerie de Marsens",
        pont: "Pont en bois, Bulle",
        chantier: "Suivi de chantier, Bulle",
        insta: "Bien d'exception",
      },
    },
    testimonials: {
      label: "Témoignages",
      title: "Ce que disent nos clients",
      items: [],
    },
    process: {
      label: "Notre Processus",
      title: "Du premier contact à la livraison",
      steps: [
        { title: "Consultation", desc: "Échange sur vos besoins, visite du bien immobilier et définition du concept créatif adapté.", image: "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Tournage", desc: "Prise de vue drone aérien, photos HDR et vidéo au sol par notre équipe sur place.", image: "https://images.pexels.com/photos/3379934/pexels-photo-3379934.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Post-production", desc: "Montage vidéo professionnel, étalonnage couleur et retouches photo pour un rendu cinéma.", image: "https://images.pexels.com/photos/2102416/pexels-photo-2102416.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Livraison", desc: "Fichiers optimisés pour vos annonces, réseaux sociaux et supports d'impression.", image: "https://images.pexels.com/photos/4050315/pexels-photo-4050315.jpeg?auto=compress&cs=tinysrgb&w=400" },
      ],
    },
    contact: {
      label: "Contact",
      title: "Réservez votre shooting immobilier",
      person: "Fondateur & Directeur de Production",
      email: "Email",
      phone: "Téléphone",
      location: "Localisation",
      locationValue: "Bulle, Suisse",
      form: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Message",
        namePh: "Votre nom",
        emailPh: "votre@email.ch",
        phonePh: "+41 7X XXX XX XX",
        subjectPh: "Objet de votre demande",
        messagePh: "Décrivez votre projet immobilier...",
        submit: "Envoyer le message",
        sending: "Envoi...",
        sent: "Envoyé !",
        errorRequired: "Veuillez remplir les champs obligatoires.",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi. Réessayez.",
      },
    },
    footer: {
      desc: "Photographe et vidéaste immobilier professionnel en Suisse romande. Drone FPV, vidéo et photo pour agences et promoteurs.",
      navigation: "Navigation",
      contact: "Contact",
      rights: "Tous droits réservés.",
      tagline: "Vidéo & photo immobilière, Suisse",
    },
    packs: {
      label: "Nos Tarifs",
      title: "Nos packs photo et vidéo immobilière",
      popular: "Populaire",
      cta: "Demander un devis",
      items: [
        {
          name: "Pack Photo",
          price: "400",
          desc: "Photos immobilières professionnelles pour valoriser votre bien.",
          features: ["Photos HD intérieures & extérieures", "Retouches professionnelles", "Livraison sous 48h", "Formats web & print"],
        },
        {
          name: "Pack Vidéo",
          price: "500",
          desc: "Vidéo immobilière cinématique avec prise de vue drone.",
          features: ["Vidéo cinématique du bien", "Prise de vue drone", "Montage professionnel", "Musique libre de droits"],
        },
        {
          name: "Pack Photo + Vidéo",
          price: "850",
          desc: "La solution complète : photos, vidéo drone et contenu réseaux sociaux.",
          features: ["Photos HD complètes", "Vidéo cinématique", "Formats réseaux sociaux", "Drone aérien inclus", "Montage Reels/Shorts"],
          popular: true,
        },
      ],
    },
    promo: {
      title: "Shooting Découverte Gratuit",
      text: "Première collaboration ? Bénéficiez d'un shooting découverte offert pour tester notre savoir-faire.",
      cta: "En profiter",
      close: "Plus tard",
    },
    faq: {
      label: "Questions Fréquentes",
      title: "Tout savoir sur nos services",
      items: [
        { q: "Comment se déroule un shooting photo immobilier ?", a: "Après un premier échange pour comprendre vos besoins, nous planifions la séance. Le jour J, notre équipe se déplace avec tout le matériel nécessaire. Les photos retouchées sont livrées sous 48h." },
        { q: "Quelle est la différence entre un drone classique et un drone FPV ?", a: "Le drone FPV (First Person View) offre une maniabilité extrême qui permet des vols à travers les pièces, des passages d'obstacles et des mouvements cinématiques impossibles avec un drone standard. Le rendu est comparable à un travelling de cinéma." },
        { q: "Quels formats de fichiers sont livrés ?", a: "Les photos sont livrées en haute résolution (JPEG et RAW sur demande). Les vidéos en MP4 4K, avec des versions optimisées pour les réseaux sociaux (format vertical 9:16 pour Reels/TikTok)." },
        { q: "Intervenez-vous en dehors de la Suisse romande ?", a: "Nous sommes basés à Bulle mais nous intervenons dans toute la Suisse. Pour des projets en dehors de la Suisse romande, des frais de déplacement peuvent s'appliquer." },
        { q: "Combien de temps dure un shooting immobilier ?", a: "Un shooting photo prend environ 1 à 2 heures selon la taille du bien. Un shooting vidéo avec drone nécessite généralement une demi-journée. Le pack complet photo + vidéo prend environ une journée." },
        { q: "Proposez-vous des abonnements pour les agences ?", a: "Oui, nous proposons des formules d'abonnement adaptées aux agences immobilières avec des tarifs préférentiels pour des shootings réguliers. Contactez-nous pour en discuter." },
        { q: "Que se passe-t-il en cas de mauvaises conditions météo ?", a: "Si la météo ne permet pas un shooting de qualité (pluie, vent fort, brouillard), nous reportons la séance sans frais à la prochaine date disponible. Les conditions idéales pour un drone sont un ciel clair ou légèrement couvert, avec peu de vent." },
        { q: "Quels sont les droits d'utilisation des fichiers livrés ?", a: "Vous recevez une licence d'utilisation complète et illimitée pour tous les fichiers livrés. Vous pouvez les utiliser pour vos annonces, site web, réseaux sociaux et supports imprimés sans restriction. Prodimmo conserve le droit de les utiliser à des fins de portfolio." },
        { q: "Quelles sont les modalités de paiement ?", a: "Le paiement s'effectue par virement bancaire ou TWINT dans les 30 jours suivant la livraison des fichiers. Un acompte de 50% peut être demandé pour les projets de grande envergure. Nous émettons une facture avec TVA incluse." },
      ],
    },
  },
  en: {
    nav: {
      accueil: "Home",
      apropos: "About",
      prestations: "Services",
      portfolio: "Portfolio",
      processus: "Process",
      tarifs: "Pricing",
      contact: "Contact",
      faq: "FAQ",
    },
    hero: {
      title1: "Real Estate Video",
      title2: "& Photo Production",
      subtitle: "Professional real estate photographer and drone videographer in Switzerland. Elevate your properties with visuals that sell.",
      cta1: "View our work",
      cta2: "Book a shooting",
    },
    about: {
      label: "Real estate production agency",
      title: "Your real estate photographer and videographer in Switzerland",
      p1: "Specializing in real estate video and property photography, Prodimmo supports real estate agencies, developers and individuals across French-speaking Switzerland. Our FPV drone and ground-level footage showcases every property with high-end cinematic quality.",
      p2: "From real estate photo shoots to aerial drone video, through to social media management, we create the visual content that turns your listings into sales.",
      stats: {
        experience: "Years of Experience",
        satisfaction: "Client Satisfaction",
      },
      badge: "years of excellence",
      highlights: ["FPV Drone", "4K Cinema", "Social Media", "Premium Quality"],
    },
    services: {
      label: "Our Services",
      title: "Drone video, real estate photography & social media",
      drone: {
        title: "FPV Drone & Aerial Video",
        desc: "Real estate drone video with FPV for immersive, cinematic shots. Smooth flyovers through rooms and around buildings, unmatched quality for your properties.",
        badge: "Real estate drone",
      },
      video: {
        title: "Real Estate Video & Photo",
        desc: "Professional real estate photographer with cinema-grade equipment. HDR photos and videos that showcase interiors, exteriors and architectural details.",
        badge: "Property photography",
      },
      social: {
        title: "Social Media Management",
        desc: "Reels, TikTok and Shorts editing to maximize your real estate listings visibility online. Content strategy and regular publishing.",
        badge: "Digital marketing",
      },
    },
    portfolio: {
      label: "Our Work",
      title: "Real estate video and photo projects",
      filters: { tous: "All", immobilier: "Real Estate", charpente: "Timber", chantier: "Construction" },
      client: "Client",
      projects: {
        payerne: "Property, Payerne",
        arbaz: "Chalet, Arbaz",
        fromagerie: "Marsens Cheese Factory",
        pont: "Wooden Bridge, Bulle",
        chantier: "Construction Follow-up, Bulle",
        insta: "Luxury Property",
      },
    },
    testimonials: {
      label: "Testimonials",
      title: "What our clients say",
      items: [],
    },
    process: {
      label: "Our Process",
      title: "From first contact to delivery",
      steps: [
        { title: "Consultation", desc: "Discussion of your needs, property visit and tailored creative concept definition.", image: "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Shooting", desc: "Aerial drone footage, HDR photos and ground-level video by our on-site team.", image: "https://images.pexels.com/photos/3379934/pexels-photo-3379934.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Post-production", desc: "Professional video editing, color grading and photo retouching for a cinema-quality result.", image: "https://images.pexels.com/photos/2102416/pexels-photo-2102416.jpeg?auto=compress&cs=tinysrgb&w=400" },
        { title: "Delivery", desc: "Files optimized for your listings, social media and print materials.", image: "https://images.pexels.com/photos/4050315/pexels-photo-4050315.jpeg?auto=compress&cs=tinysrgb&w=400" },
      ],
    },
    contact: {
      label: "Contact",
      title: "Book your real estate shooting",
      person: "Founder & Production Director",
      email: "Email",
      phone: "Phone",
      location: "Location",
      locationValue: "Bulle, Switzerland",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        namePh: "Your name",
        emailPh: "your@email.ch",
        phonePh: "+41 7X XXX XX XX",
        subjectPh: "Subject of your request",
        messagePh: "Describe your real estate project...",
        submit: "Send message",
        sending: "Sending...",
        sent: "Sent!",
        errorRequired: "Please fill in the required fields.",
        success: "Message sent successfully!",
        error: "Error sending message. Please try again.",
      },
    },
    footer: {
      desc: "Professional real estate photographer and videographer in French-speaking Switzerland. FPV drone, video and photo for agencies and developers.",
      navigation: "Navigation",
      contact: "Contact",
      rights: "All rights reserved.",
      tagline: "Real estate video & photo, Switzerland",
    },
    packs: {
      label: "Pricing",
      title: "Our real estate photo & video packs",
      popular: "Popular",
      cta: "Request a quote",
      items: [
        {
          name: "Photo Pack",
          price: "400",
          desc: "Professional real estate photos to showcase your property.",
          features: ["HD interior & exterior photos", "Professional retouching", "Delivery within 48h", "Web & print formats"],
        },
        {
          name: "Video Pack",
          price: "500",
          desc: "Cinematic real estate video with drone footage.",
          features: ["Cinematic property video", "Drone footage", "Professional editing", "Royalty-free music"],
        },
        {
          name: "Photo + Video Pack",
          price: "850",
          desc: "The complete solution: photos, drone video and social media content.",
          features: ["Complete HD photos", "Cinematic video", "Social media formats", "Aerial drone included", "Reels/Shorts editing"],
          popular: true,
        },
      ],
    },
    promo: {
      title: "Free Discovery Shooting",
      text: "First collaboration? Get a free discovery shooting to experience our expertise.",
      cta: "Claim now",
      close: "Maybe later",
    },
    faq: {
      label: "Frequently Asked Questions",
      title: "Everything about our services",
      items: [
        { q: "How does a real estate photo shoot work?", a: "After an initial exchange to understand your needs, we plan the session. On the day, our team comes with all necessary equipment. Retouched photos are delivered within 48 hours." },
        { q: "What's the difference between a standard drone and an FPV drone?", a: "The FPV (First Person View) drone offers extreme maneuverability allowing flights through rooms, obstacle passes and cinematic movements impossible with a standard drone. The result is comparable to a cinema tracking shot." },
        { q: "What file formats are delivered?", a: "Photos are delivered in high resolution (JPEG and RAW on request). Videos in 4K MP4, with versions optimized for social media (vertical 9:16 format for Reels/TikTok)." },
        { q: "Do you operate outside French-speaking Switzerland?", a: "We are based in Bulle but we operate throughout Switzerland. For projects outside French-speaking Switzerland, travel fees may apply." },
        { q: "How long does a real estate shoot take?", a: "A photo shoot takes approximately 1 to 2 hours depending on the property size. A video shoot with drone typically requires half a day. The complete photo + video pack takes about a full day." },
        { q: "Do you offer subscriptions for agencies?", a: "Yes, we offer subscription plans tailored to real estate agencies with preferential rates for regular shoots. Contact us to discuss." },
        { q: "What happens in case of bad weather?", a: "If weather conditions don't allow a quality shoot (rain, strong wind, fog), we reschedule at no extra cost to the next available date. Ideal drone conditions are clear or slightly overcast skies with little wind." },
        { q: "What are the usage rights for delivered files?", a: "You receive a complete and unlimited usage license for all delivered files. You can use them for your listings, website, social media and print materials without restrictions. Prodimmo retains the right to use them for portfolio purposes." },
        { q: "What are the payment terms?", a: "Payment is made by bank transfer or TWINT within 30 days of file delivery. A 50% deposit may be required for large projects. We issue an invoice with VAT included." },
      ],
    },
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const [switching, setSwitching] = useState(false);
  const t = translations[lang];
  const toggleLang = () => {
    setSwitching(true);
    setTimeout(() => {
      setLang((l) => (l === "fr" ? "en" : "fr"));
      setTimeout(() => setSwitching(false), 300);
    }, 200);
  };
  return (
    <LangContext.Provider value={{ lang, t, toggleLang, switching }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
